// components/DealershipCard.js
import React from 'react';

function CopyButton({ text }) {
  const [copied, setCopied] = React.useState(false);
  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
  return (
    <button
      onClick={handleCopy}
      title="Copy to clipboard"
      style={{
        marginLeft: 6,
        padding: '1px 7px',
        fontSize: 11,
        backgroundColor: copied ? '#28a745' : '#e9ecef',
        color: copied ? 'white' : '#555',
        border: '1px solid ' + (copied ? '#28a745' : '#ccc'),
        borderRadius: 4,
        cursor: 'pointer',
        verticalAlign: 'middle',
        transition: 'all 0.15s ease',
        lineHeight: '18px'
      }}
    >
      {copied ? '✓ Copied' : 'Copy'}
    </button>
  );
}

export default function DealershipCard({ dealershipInfo, clientId, navigate }) {
  if (!dealershipInfo) return null;

  return (
    <div className="dealership-card flex flex-wrap items-center justify-center gap-7">
      {dealershipInfo.blackLogo ? (
        <img 
          src={dealershipInfo.blackLogo} 
          alt="Dealership Logo"     
          style={{ width: '200px', height: 'auto' }} 
        />
      ) : (
        <p>No logo available</p>
      )}
      
      <p><strong>Name:</strong> {dealershipInfo.name}{dealershipInfo.name && <CopyButton text={dealershipInfo.name} />}</p>
      
      {dealershipInfo.phone && (
        <p><strong>Phone:</strong> {dealershipInfo.phone}<CopyButton text={dealershipInfo.phone} /></p>
      )}

      {dealershipInfo.street1 && (
        <p>
          <strong>Address:</strong> {dealershipInfo.street1}
          {dealershipInfo.street2 && `, ${dealershipInfo.street2}`}, {' '}   
          {dealershipInfo.city}, {dealershipInfo.state} {dealershipInfo.zip}
          <CopyButton text={[dealershipInfo.street1, dealershipInfo.street2, dealershipInfo.city, dealershipInfo.state, dealershipInfo.zip].filter(Boolean).join(', ')} />
        </p>
      )}

      {dealershipInfo.email && (
        <p><strong>Email:</strong> {dealershipInfo.email}<CopyButton text={dealershipInfo.email} /></p>
      )}

      {dealershipInfo.generalManager && (
        <p><strong>General Manager:</strong> {dealershipInfo.generalManager}<CopyButton text={dealershipInfo.generalManager} /></p>
      )}

      {dealershipInfo.dealershipWebsite ? (
        <p>
          <strong>Website:</strong>{' '}
          <a
            href={dealershipInfo.dealershipWebsite.startsWith('http') 
              ? dealershipInfo.dealershipWebsite 
              : `https://${dealershipInfo.dealershipWebsite}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => e.stopPropagation()}
            style={{ textDecoration: 'underline', color: 'blue' }}
          >
            {dealershipInfo.dealershipWebsite}
          </a>
          <CopyButton text={dealershipInfo.dealershipWebsite} />
        </p>
      ) : (
        <p><strong>Website:</strong> <em>No website</em></p>
      )}

      <div className="client-actions" style={{ marginBottom: '10px' }}>
        <button
          type="button"
          disabled={!clientId}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          onClick={() => navigate(`/clients/${clientId}`)}
        >
          View Client Profile
        </button>
      </div>
    </div>
  );
}